import { render, staticRenderFns } from "./LabDialog.vue?vue&type=template&id=d9e3d532&scoped=true"
import script from "./LabDialog.vue?vue&type=script&lang=js"
export * from "./LabDialog.vue?vue&type=script&lang=js"
import style0 from "./LabDialog.vue?vue&type=style&index=0&id=d9e3d532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e3d532",
  null
  
)

export default component.exports